// extracted by mini-css-extract-plugin
export default {"item":"form-item_item__dtMX3","noMargin":"form-item_noMargin__jQ27n","errorMessage":"form-item_errorMessage__Rw2vo"};